/*
 * @Author: Tahiti
 * @Date: 2025-12-23 14:37:32
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-23 18:25:57
 * @Description:
 * @FilePath: /weryai-web/locales/modules/img_extender.ts
 */
export default {
    zh: {
        title: 'AI图片扩展器',
        reEdit: '重新编辑',
        width: '宽',
        height: '高',
        canvasSizeError: '输出画布尺寸不能超过5000*5000，请调整比例',
    },
    en: {
        title: 'AI Image Extender',
        reEdit: 'Re-Edit',
        width: 'Width',
        height: 'Height',
        canvasSizeError:
            'The output canvas size cannot exceed 5000*5000, please adjust the ratio',
    },
    ja: {
        title: 'AI画像拡張器',
        reEdit: '再編集',
        width: '幅',
        height: '高さ',
        canvasSizeError:
            '出力画布サイズは5000*5000を超えることはできません。比率を調整してください',
    },
    ko: {
        title: 'AI 이미지 확장기',
        reEdit: '다시 편집',
        width: '너비',
        height: '높이',
        canvasSizeError:
            '출력 캔버스 크기는 5000*5000을 초과할 수 없습니다. 비율을 조정하세요',
    },
    tw: {
        title: 'AI 圖片擴展器',
        reEdit: '重新編輯',
        width: '寬',
        height: '高',
        canvasSizeError: '輸出畫布尺寸不能超過 5000*5000，請調整比例',
    },
    pl: {
        title: 'Rozszerzacz obrazów AI',
        reEdit: 'Edytuj ponownie',
        width: 'Szerokość',
        height: 'Wysokość',
        canvasSizeError:
            'Rozmiar płótna wyjściowego nie może przekroczyć 5000*5000, dostosuj proporcje',
    },
    es: {
        title: 'Extensor de Imagen IA',
        reEdit: 'Re-Editar',
        width: 'Ancho',
        height: 'Altura',
        canvasSizeError:
            'El tamaño del lienzo de salida no puede exceder 5000*5000. Por favor, ajuste la proporción',
    },
    fr: {
        title: "Extenseur d'Image IA",
        reEdit: 'Re-Modifier',
        width: 'Largeur',
        height: 'Hauteur',
        canvasSizeError:
            'La taille du canevas de sortie ne peut pas dépasser 5000*5000. Veuillez ajuster le rapport',
    },
    ru: {
        title: 'Расширитель изображений IA',
        reEdit: 'Перередактировать',
        width: 'Ширина',
        height: 'Высота',
        canvasSizeError:
            'Размер выходного холста не может превышать 5000*5000. Пожалуйста, отрегулируйте пропорцию',
    },
    pt: {
        title: 'Extensor de Imagem IA',
        reEdit: 'Re-Editar',
        width: 'Largura',
        height: 'Altura',
        canvasSizeError:
            'O tamanho do canvas de saída não pode exceder 5000*5000. Por favor, ajuste a proporção',
    },
    it: {
        title: 'Estensore di Immagine IA',
        reEdit: 'Riedita',
        width: 'Larghezza',
        height: 'Altezza',
        canvasSizeError:
            'La dimensione del canvas di output non può superare 5000*5000. Per favore, regola la proporzione',
    },
    ar: {
        title: 'مُزيّت الصورة الذكية',
        reEdit: 'إعادة التحرير',
        width: 'العرض',
        height: 'الإرتفاع',
        canvasSizeError:
            'إن الحجم الإجمالي للرسم التخطيطي لا يمكن أن يتجاوز 5000*5000. يرجى ضبط النسبة',
    },
    de: {
        title: 'AI Bild-Erweiterer',
        reEdit: 'Neu bearbeiten',
        width: 'Breite',
        height: 'Höhe',
        canvasSizeError:
            'Die Ausgabe-Canvas-Größe darf 5000*5000 nicht überschreiten. Bitte passen Sie das Verhältnis an',
    },
    th: {
        title: 'AI Image Extender',
        reEdit: 'Re-Edit',
        width: 'Width',
        height: 'Height',
        canvasSizeError:
            'The output canvas size cannot exceed 5000*5000, please adjust the ratio',
    },
    da: {
        title: 'AI Image Extender',
        reEdit: 'Re-Edit',
        width: 'Width',
        height: 'Height',
        canvasSizeError:
            'The output canvas size cannot exceed 5000*5000, please adjust the ratio',
    },
    no: {
        title: 'AI Image Extender',
        reEdit: 'Re-Edit',
        width: 'Width',
        height: 'Height',
        canvasSizeError:
            'The output canvas size cannot exceed 5000*5000, please adjust the ratio',
    },
    nl: {
        title: 'AI Image Extender',
        reEdit: 'Re-Edit',
        width: 'Width',
        height: 'Height',
        canvasSizeError:
            'The output canvas size cannot exceed 5000*5000, please adjust the ratio',
    },
    id: {
        title: 'AI Image Extender',
        reEdit: 'Re-Edit',
        width: 'Width',
        height: 'Height',
        canvasSizeError:
            'The output canvas size cannot exceed 5000*5000, please adjust the ratio',
    },
    tr: {
        title: 'AI Image Extender',
        reEdit: 'Re-Edit',
        width: 'Width',
        height: 'Height',
        canvasSizeError:
            'The output canvas size cannot exceed 5000*5000, please adjust the ratio',
    },
}
